export default "__VITE_ASSET__BvZBbTr6__"